module.exports = __webpack_public_path__ + "static/media/ImageTemplateIntro.15bfa507.jpg";